import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

/**
 * Premium Level Badge Component with animation
 * Displays affiliate level with badge icon and glow effect
 */
const LevelBadge = ({ level, size = 'large' }) => {
  const sizeClasses = {
    small: 'text-2xl',
    medium: 'text-4xl',
    large: 'text-6xl'
  };

  const containerSizes = {
    small: 'w-16 h-16',
    medium: 'w-24 h-24',
    large: 'w-32 h-32'
  };

  if (!level) return null;

  return (
    <motion.div
      initial={{ scale: 0, rotate: -180 }}
      animate={{ scale: 1, rotate: 0 }}
      transition={{ type: 'spring', stiffness: 200, damping: 15 }}
      className="relative inline-block"
    >
      {/* Glow background */}
      <motion.div
        animate={{
          boxShadow: [
            '0 0 30px rgba(251, 191, 36, 0.4)',
            '0 0 60px rgba(251, 191, 36, 0.6)',
            '0 0 30px rgba(251, 191, 36, 0.4)'
          ]
        }}
        transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
        className={`${containerSizes[size]} rounded-full bg-gradient-to-br from-amber-400 via-yellow-500 to-amber-600 flex items-center justify-center relative overflow-hidden`}
      >
        {/* Sparkle effect */}
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
          className="absolute inset-0 opacity-20"
        >
          <Sparkles className="absolute top-2 left-2 text-white" size={size === 'small' ? 12 : 16} />
          <Sparkles className="absolute bottom-2 right-2 text-white" size={size === 'small' ? 12 : 16} />
        </motion.div>

        {/* Badge icon */}
        <span className={`${sizeClasses[size]} relative z-10`}>
          {level.badge || '🥉'}
        </span>
      </motion.div>

      {/* Level name */}
      <div className="text-center mt-2">
        <p className="font-bold text-lg text-gray-800">{level.name}</p>
        <p className="text-sm text-amber-600 font-semibold">{level.commission_rate}% commission</p>
      </div>
    </motion.div>
  );
};

export default LevelBadge;
